import { render, staticRenderFns } from "./PhotoReportItemComponent.vue?vue&type=template&id=64520381&scoped=true&"
import script from "./PhotoReportItemComponent.vue?vue&type=script&lang=js&"
export * from "./PhotoReportItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./PhotoReportItemComponent.vue?vue&type=style&index=0&id=64520381&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64520381",
  null
  
)

export default component.exports